module.exports = __webpack_public_path__ + "static/media/lawyer.cdf8aef0.svg";